module.exports = __webpack_public_path__ + "static/media/amla-candy.f654a5fc.jpg";